module.exports = __webpack_public_path__ + "images/psp/militarySizeGuide/unit-5x10.svg";